import {
    ADD_COMPANY_ERROR,
    ADD_COMPANY_PENDING,
    ADD_COMPANY_SUCCESS,
    CLEAR_NEWLY_ADDED_COMPANY,
    GET_COMPANIES_ERROR,
    GET_COMPANIES_PENDING,
    GET_COMPANIES_SUCCESS,
    FILTER_COMPANIES_PENDING,
    FILTER_COMPANIES_SUCCESS, CLEAR_FILTER_COMPANIES
} from "./types";
import {message} from "antd";
import api from "../../api/api";
import HttpResponseStatus from "../../constants/HttpResponseStatus";
import {
    COMPANIES_POST_URL,
    COMPANIES_POST_URL_SIMPLE,
    COMPANIES_PUT_URL,
    COMPANIES_URL
} from "../../constants/urlConfig";
import {arrayContainsItemWithProperty} from "../../util/arrayUtils";
import DataType from "../../constants/DataType";

const clearNewlyAddedCompany = () => ({
    type: CLEAR_NEWLY_ADDED_COMPANY
});

const getCompanies = () => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    try {
        dispatch({type: GET_COMPANIES_PENDING});
        const {data} = await api.get(COMPANIES_URL);
        dispatch({type: GET_COMPANIES_SUCCESS, payload: data});
    } catch (e) {
        message.error({
            content: 'An error has occurred while loading companies.',
            className: darkMode && "dark-mode"
        });
        dispatch({type: GET_COMPANIES_ERROR, payload: e})
    }
};

const saveCompany = (company, companyId) => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    try {
        dispatch({type: ADD_COMPANY_PENDING});
        if (companyId) {
            const {data} = await api.put(COMPANIES_PUT_URL.replace('{id}', companyId), {...company, id: companyId});

            dispatch({type: ADD_COMPANY_SUCCESS, payload: data});
        } else {
            if (company.products && company.products.length) {
                const companyHasSoftwareProducts = company.products.map(({softwareProductId, code}) => ({
                    softwareProductId,
                    code
                }));

                const {data} = await api.post(COMPANIES_POST_URL, {
                    company,
                    companyHasSoftwareProducts
                });

                dispatch({type: ADD_COMPANY_SUCCESS, payload: data.company});
            } else {

                const {data} = await api.post(COMPANIES_POST_URL_SIMPLE, company);

                dispatch({type: ADD_COMPANY_SUCCESS, payload: data});
            }
        }
        message.success({
            content: "Data successfully saved.",
            className: darkMode && "dark-mode"
        });
    } catch (e) {
        if (e.response.status === HttpResponseStatus.CONFLICT) {
            message.error({
                content: e.response.data.data,
                className: darkMode && "dark-mode"
            });
        } else {
            message.error({
                content: 'An error has occurred while saving company.',
                className: darkMode && "dark-mode"
            });
        }
        dispatch({type: ADD_COMPANY_ERROR, payload: e})
    }
};

const clearCompaniesFilter = () => ({
    type: CLEAR_FILTER_COMPANIES
});

const filterCompanies = providedFilter => async (dispatch, getState) => {
    const {companies, filterValues} = getState().company;

    const filterExists = arrayContainsItemWithProperty(filterValues, 'key', providedFilter.key);
    let newFilterValues = filterValues;
    if (filterExists) {
        newFilterValues = filterValues.map(p =>
            p.key === providedFilter.key
                ? { ...providedFilter }
                : p
        );
    } else {
        newFilterValues.push(providedFilter);
    }

    dispatch({type: FILTER_COMPANIES_PENDING, payload: newFilterValues});
    const filteredCompanies = companies.filter(item => {

        let shouldShowItem = true;
        newFilterValues.forEach(fMap => {
            if (fMap.type === DataType.SELECT || fMap.type === DataType.MULTI_SELECT) {
                if (item[fMap.key] !== fMap.value)
                    shouldShowItem = false;
            }
            else if (item[fMap.key].toLowerCase().indexOf(fMap.value.toLowerCase()) === -1)
                shouldShowItem = false;
        });
        if (shouldShowItem)
            return true
    });
    dispatch({type: FILTER_COMPANIES_SUCCESS, payload: filteredCompanies});
};

export {getCompanies, saveCompany, clearNewlyAddedCompany, clearCompaniesFilter, filterCompanies}